import React from "react";
import { SxProps, Theme } from "@mui/material";
import theme from "../themes/ichat";

export const backendLoadingModal: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

export const loadingBox: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "1.5rem",
  borderRadius: "20px",
  background: "var(--light_gray)",
  width: "400px",
  minHeight: "250px",
  padding: "3rem 2rem",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)",
  textAlign: "center",
  [theme.breakpoints.down(500)]: {
    width: "90%",
    padding: "2rem 1.5rem",
  },
};

export const loadingTitle: SxProps<Theme> = {
  color: "white",
  fontWeight: 500,
  marginTop: "0.5rem",
};

export const loadingSubtext: SxProps<Theme> = {
  color: "rgba(255, 255, 255, 0.8)",
  maxWidth: "300px",
  lineHeight: 1.6,
};

export const loadingHint: SxProps<Theme> = {
  color: "rgba(255, 255, 255, 0.6)",
  fontStyle: "italic",
};

export const modalBackdrop: React.CSSProperties = {
  zIndex: -1,
  position: "fixed",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.7)",
};
